import QRCode from 'qrcode'
import { v4 as uuidv4 } from 'uuid';
import BrCode from '@iso/lib/helpers/BrCode';
import React, { useState, useRef } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
// import { payload, PIX } from 'react-qrcode-pix';
import "@iso/containers/PDV/styles/pdvStyles.css"
import Loader from '@iso/components/utility/loader';
import Tooltip from '@iso/components/Tooltip/Tooltip';
import MoneyInput from '@iso/components/MoneyInput.js';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Layout, Row, Col, notification, Modal, Table, Input } from 'antd';
import { Fieldset, Label } from '@iso/containers/Registration/People/SinglePeople.styles.js';
import { textLimit, onlyNumber, convertToNumber, findObjIntoArrayByProp, testEmpty, formatMoney } from '@iso/lib/helpers/utility';

import apiPDV from '@iso/services/repository/pdv';
import cashBoxApi from '@iso/services/repository/cashbox';
import notasApi from '@iso/services/repository/notafiscal';

import { OrderStatus } from './scripts/storeOrders';
import { saveClients } from './scripts/storeClients';
import { saveProducts } from './scripts/storeProducts';
import { getConfig, saveConfig } from './scripts/storeConfigs';

import { savePaymentForms } from '@iso/containers/PDV/scripts/storePaymentForms';
import { savePaymentConditions } from '@iso/containers/PDV/scripts/storePaymentConditions';

import notificationMessage from '@iso/components/Notification';

import DesktopWSControll from '@iso/lib/helpers/desktop';

import Logo from './components/Logo';
import TopBar from './TopBar/TopBar';
import FooterBar from './FooterBar/FooterBar';
import TextArea from 'antd/lib/input/TextArea';
import CancelItem from './components/CancelItem';
import ValueInputs from './components/ValueInputs';
import SelectClient from './components/SelectClient';
import FinalizarVenda from './components/FinalizarVenda';
import CancelSalesModal from './components/CancelSalesModal';
import ListPaymentForms from './components/ListPaymentForms';
import AcrescimoDescontoVenda from './components/AcrescimoDescontoVenda';
import EmissaoModal from '@iso/components/Integration/NotaFiscal/EmissaoModal';
import { Cfop } from '@iso/containers/Integration/NotasFiscais/cfop';

const { confirm } = Modal;
const topFootColor = '#DDD';
const maxVHHeight = '58vh';
const caixaLivre = 'CAIXA LIVRE';
const finalizarVenda = 'FINALIZAR VENDA';
const digiteParaBuscar = 'DIGITE PARA BUSCAR';

const QR_CODE_SIZE = 350;

const KEYS_TYPES = {
    'CPF': 'CPF',
    'CNPJ': 'CNPJ',
    'EMAIL': 'Email',
    'PHONE': 'Telefone',
    'EVP': 'Outro',
}

const All_Components = {
    'logo': Logo,
    'cancel_Item': CancelItem,
    'value_inputs': ValueInputs,
    'select_client': SelectClient,
    'finalizar_venda': FinalizarVenda,
    'acrescimo_desconto_venda': AcrescimoDescontoVenda,
}

let CONFIG_DATA = {
    nfce: {
        // emissao: '2', // 1 - Automática, 2 - Pedir se deseja emitir, 3 - Emissão manual usando tecla de atalho (F7 por exemplo)
        // cfop: '5.102',
        // cst_ipi: '99',
        // cst_pis: '49',
        // cst_icms: '00',
        // cst_cofins: '49',
        // ind_presenca: '1',
        // tp_tributacao: 'S'
    }
}

let defaultButtons = [
    // {
    //     label: 'Ajuda',
    //     key: 'F1',
    //     call: 'showHelp',
    // },
    {
        label: 'Identificar Cliente',
        key: 'F2',
        call: 'selectCustumer',
    },
    // {
    //     label:'Acres/Desc Item',
    //     key:'F3',
    //     call:'selectCustumer',
    // },
    {
        label: 'Cancelar Item',
        key: 'F3',
        call: 'requestCancelItem',
    },
    // {
    //     label:'Info Adic Item',
    //     key:'F4',
    //     call:'selectCustumer',
    // },
    {
        label: 'Acres/Desc Venda',
        key: 'F4',
        call: 'requestDiscountOrAddictionToOrder',
    },
    // {
    //     label: 'Info Adic Venda',
    //     key: 'F5',
    //     call: 'selectCustumer',
    // },
    {
        label: 'Finalizar Venda',
        key: 'F6',
        call: 'finishOrder',
    },
    {
        label: 'Cancelar Venda',
        key: 'F7',
        call: 'cancelOrder',
    },
    {
        label: 'Sangria',
        key: 'F8',
        class: 'cashBoxBtn',
        call: 'withdrawalCashBox',
    },
    {
        label: 'Suprimento',
        key: 'F9',
        class: 'cashBoxBtn',
        call: 'supplyCashBox',
    },
    {
        label: 'Fechar caixa',
        key: 'F10',
        class: 'cashBoxBtn',
        call: 'closeCashBox',
    },
];

export default function () {
    /*
    const sesPer = sessionStorage.getItem("permissions");
    const arraySplitPer = b64_to_utf8(sesPer).split(",");
    const ses = sessionStorage.getItem("boards_access");
    const arraySplit = b64_to_utf8(ses).split(",");
    */

    let Component;
    let currentQuantity = 1;
    let intervalListning = null;

    const [isOnline, setIsOnline] = useState(navigator.onLine);

    const refTopBar = useRef(null)
    const refFooterBar = useRef(null)
    const refEmissaoModal = useRef(null);

    const [canUse, setCanUse] = useState(false);
    const [loadButton, setLoadButton] = useState(false);
    const [loadCancelSale, setLoadCancelSale] = useState(false);
    const [openCashRegister, setOpenCashRegister] = useState(false);
    const [closeCashRegister, setCloseCashRegister] = useState(false);
    const [currentCashBoxMovement, setCurrentCashBoxMovement] = useState({});
    const [openCashBoxMovementModal, setOpenCashBoxMovementModal] = useState(false);
    const [startCashBoxData, setStartCashBoxData] = useState({startValue: 0, suprimentValue: 0});

    const [clients, setClients] = useState([]);
    const [products, setProducts] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [currentProduct, setCurrentProduct] = useState(null);
    const [api, contextHolder] = notification.useNotification();
    const [CurrentComponent, setCurrentComponent] = useState('logo');

    const [currentPayment, setCurrentPayment] = useState(null);
    const [currentPaymentIdx, setCurrentPaymentIdx] = useState(null);

    const [currentTableItem, setCurrentTableItem] = useState(null);
    const [currentTableItemIdx, setCurrentTableItemIdx] = useState(null);

    const [showPaymentsList, setShowPaymentsList] = useState(false);
    
    const [pixKey, setPixKey] = useState({});
    const [auxFunction, setAuxFunction] = useState();
    const [openKeyPIX, setOpenKeyPIX] = useState(false);
    const [cancelSaleData, setCancelSaleData] = useState({});
    const [mainInputValue, setMainInputValue] = useState('');
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const [currentOrder, setCurrentOrder] = useState({ itens: [] });
    const [paymentPIXStatus, setPaymentPIXStatus] = useState(false);
    const [mainInputValuePlaceholder, setMainInputValuePlaceholder] = useState(caixaLivre);

    const [buttons, setButtons] = useState(defaultButtons);

    const handleNetworkChange = () => {
        setIsOnline(navigator.onLine);

        if (navigator.onLine)
            apiPDV.sincPendingOrders();
    }

    const createNewOrder = () => {
        setCurrentOrder({
            itens: [],
            amount: 0,
            subtotal: 0,
            discount: 0,
            addition: 0,
            client: null,
            source: 'pdv',
            payment: {
                paid: 0,
                change: 0,
                balance: 0,
                methods: []
            },
            local_id: uuidv4(),
            status: OrderStatus.Pending,
            userId: localStorage.getItem("userCo"),
            cashboxId: CONFIG_DATA.cashbox || null
        })
    }

    React.useEffect(() => {
        // if (arraySplit.includes('') || arraySplitPer.includes('all')) {
        window.addEventListener('online', handleNetworkChange);
        window.addEventListener('offline', handleNetworkChange);

        getProducts();
        getClients();
        createNewOrder();
        getPDVConfigs();

        // DesktopWSControll.start(handleWS);

        // } else {
        //     history.push('/dashboard/scrum-board');
        // }

        // showPix('0.06');

        //*
        // setTimeout(() => {
        // handleNFCe();
        //     afterEmitNFCe('67aeeb5c-5b25-43ff-8ab2-6c33c8a3f387');
        // }, 1000);
        //*/

        // apiPDV.getPixKey()

        // showModalNFCe();

        // setTimeout(() => {
        //     setCurrentComponent('value_inputs')
        // }, 5000);

        return () => {
            try {
                window.removeEventListener('online', handleNetworkChange);
                window.removeEventListener('offline', handleNetworkChange);
            } catch (error) { }
        }
    }, []);

    const mainInputFocus = () => {
        try {    
            document.getElementsByClassName("mainInput")[0].focus();
        } catch (error) {
            
        }
    }

    const handleWS = (action, data) => {
        console.log(action, data);
    }

    const closeModalPix = () => {
        setOpenKeyPIX(false);
    }

    const showPix = (amount) => {
        getConfig('pix').then(res => {

            if (res !== undefined && res?.key && res?.type) {

                /*
                const qrCodePayload = res.qrCode.payload;

                // console.log("qrCodePayload:", qrCodePayload);

                let idTransacao = '', cidade, nomeEmpresa;

                // const regex = /62\d{2}(?:.{0,2})05(\d{2})(.{1,25})/;
                // const match = qrCodePayload.match(regex);
                // if (match)
                //     idTransacao = match[2]; // O valor do ID da transação

                const regexCidade = /60(\d{2})(.{1,15})62/;
                const matchCidade = qrCodePayload.match(regexCidade);

                if (matchCidade)
                    cidade = matchCidade[2];
                else
                    cidade = res.city;

                const regexEmpresa = /59(\d{2})(.{1,25})60/;
                const matchEmpresa = qrCodePayload.match(regexEmpresa);

                if (matchEmpresa)
                    nomeEmpresa = matchEmpresa[2]; // O nome da empresa
    
                // return;
    
                // let pixData = {
                //     key: res.key,
                //     name: res.name,
                //     amount: amount,
                //     reference: reference,
                //     code: res.qrCode.payload,
                //     qrcode_base64: `data:image/png;base64,${res.qrCode.encodedImage}`,
                // };

                let key = res.key, 
                    reference = '',
                    city = cidade,
                    name = nomeEmpresa,
                    key_type = 'Outro';

                */

                let key = res.key,
                    city = res.city,
                    name = res.name,
                    key_type = KEYS_TYPES[res.type],
                    reference = textLimit('P7' + onlyNumber(uuidv4()), 22, '');

                var brCode = new BrCode();

                // name = 'Luis Carlos Steffens';

                var code = brCode.generate_qrcp(key, amount, name, reference, key_type, city)

                // console.log('code: ', code)

                QRCode.toDataURL(code, { width: QR_CODE_SIZE, height: QR_CODE_SIZE }).then(qr64 => {
                    let pixData = {
                        key: key,
                        code: code,
                        name: name,
                        amount: amount,
                        qrcode_base64: qr64,
                        reference: reference
                    };

                    // console.log(pixData);

                    setPixKey(pixData)

                    setOpenKeyPIX(true);

                    // setTimeout(() => {
                    // intervalListning = setInterval(() => {
                    //     listingPaymentPIX(pixData);
                    // }, 3000); 
                    // }, 5000);
                })
                    .catch(err => {
                        console.error(err)
                    })
            }
        })
    }

    const finishIntervalLintingPaymentPix = () => {
        if (intervalListning != null)
            clearInterval(intervalListning);
    }

    const listingPaymentPIX = (data) => {
        try {
            apiPDV.listingPaymentPIX(data).then(res => {
                // console.log(res);

                if (!res.data.error) {
                    if (res.data.data.length > 0) {
                        let paym = res.data.data.find(p => p.pixQrCodeId === data.reference);
                        // let paym = res.data.data.find(p => p.value === parseFloat(data.amount));
                        // console.log(paym);

                        if (paym) {
                            setPaymentPIXStatus(true);
                            finishIntervalLintingPaymentPix();
                        }
                    }
                }
                else
                    finishIntervalLintingPaymentPix();
            })
        } catch (error) {
            console.log('listingPaymentPIX: ', error);
        }
    }

    const getPDVConfigs = () => {
        apiPDV.getPDVConfigs(isOnline).then(r => {

            if (typeof r.data.error === 'undefined' && isOnline) {

                let dt = r.data.pix;
                dt['_id'] = 'pix';
                saveConfig(dt)

                dt = r.data.configs;
                dt['_id'] = 'pdv_config';
                saveConfig(dt);

                CONFIG_DATA = dt;
                // console.log('CONFIG_DATA: ', CONFIG_DATA);

                if(CONFIG_DATA.control_cash === 'S') {

                    if(r.data.cashbox?.id) {
                        CONFIG_DATA.cashbox = r.data.cashbox.id;

                        setCurrentOrder((prev) => {
                            return { ...prev, cashboxId: CONFIG_DATA.cashbox }
                        });

                        setCanUse(true);
                        mainInputFocus()
                    }
                    else
                        setOpenCashRegister(true)
                }
                else {
                    setCanUse(true);
                    mainInputFocus();

                    let elments = Object.values(document.getElementsByClassName('cashBoxBtn'));

                    elments.forEach(element => {
                        element.style.display = 'none'
                    });
                }

                savePaymentForms(r.data.paymentForms);
                savePaymentConditions(r.data.paymentConditions);
            }
        })
    }

    const getProducts = () => {
        apiPDV.getProducts(isOnline).then(r => {

            if (typeof r.data.error === 'undefined') {
                if (isOnline)
                    saveProducts(r.data);

                setProducts(r.data.map((item, i) => {
                    return {
                        ...item,
                        // codigo: 'P_' + (i + 1),
                        codigo: item.sku || '',
                        normalized: normalizeString(item.name)
                    }
                }))
            }
        })
    }

    const getClients = () => {
        apiPDV.getClients(isOnline).then(r => {

            if (typeof r.data.error === 'undefined') {
                if (isOnline)
                    saveClients(r.data);

                setClients(r.data.map((item, i) => {
                    return {
                        ...item,
                        normalized: normalizeString(item.name)
                    }
                }))
            }
        })
    }

    /********   Input seleção de produtos *********** */

    const normalizeString = (t) => {
        return t.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }

    const getListItens = () => {
        return document.querySelectorAll('#mySuggestionsList li');
    }

    let currentIndex = -1, listItems;

    const updateSelection = () => {
        listItems = getListItens();

        listItems.forEach(item => item.classList.remove('selected'));

        if (currentIndex >= 0) {
            listItems[currentIndex].classList.add('selected');
            listItems[currentIndex].scrollIntoView({ block: "nearest", behavior: "smooth" });
        }
    }

    const closeSuggestionsList = () => {
        // console.log('closeSuggestionsList()')
        currentIndex = -1;
        setSuggestions([])
        document.getElementsByClassName("mainInput")[0].focus();
        updateSelection();
    }

    const setSelectedProd = (id) => {
        try {
            let idx = findObjIntoArrayByProp(products, '_id', id);
            if (idx !== -1) {
                let prod = products[idx];
                setCurrentProduct(prod);
                setMainInputValue(prod.name);
            }
        } catch (error) { console.log(error) }
    }

    const handleSuggestionClick = (event) => {
        let elm = event.target;

        while (elm.tagName !== 'LI') {
            elm = elm.parentElement;
        }

        let id = elm.dataset.id;

        setSelectedProd(id);
        closeSuggestionsList();
    }

    const handleKeyDown = (event) => {
        // console.log('event.key = ', event.key);
        // console.log('suggestions.length = ', suggestions.length);

        if (suggestions.length > 0) {

            listItems = getListItens();

            if (event.key === 'ArrowDown') {
                if (currentIndex < listItems.length - 1) {
                    currentIndex++;
                    updateSelection();
                }
            }
            else if (event.key === 'ArrowUp') {
                if (currentIndex > 0) {
                    currentIndex--;
                    updateSelection();
                }
            }
            else if (event.key === 'Enter') {
                if (currentIndex > -1) {
                    setSelectedProd(listItems[currentIndex].dataset.id);
                    closeSuggestionsList();
                    // document.removeEventListener('keydown', handleKeyDown);
                }
            }
        }
        else {
            let btns = buttons.filter(b => b.key === event.key)

            if (btns.length > 0)
                eval(btns[0]['call'])(event);
            else if (event.key === 'Enter' && currentProduct !== null) {
                let regex = /\*(\d+)$/;
                let str = event.target.value;

                let match = str.match(regex);

                if (match)
                    currentQuantity = match[1];
                else
                    currentQuantity = CONFIG_DATA?.default_qtd || 1;

                addProductToOrder();
            }
        }

        if (event.key === 'Escape') {
            if (suggestions.length > 0)
                closeSuggestionsList();
            else {
                // console.log(event.target);

                if (currentTableItem !== null) {
                    setCurrentTableItem(null)
                    setCurrentTableItemIdx(null)
                }

                restoreDefaultComponent()
                // console.log('currentOrder.payment.methods.length: ', currentOrder.payment.methods.length)
                if (currentOrder?.payment?.methods.length === 0)
                    setShowPaymentsList(false);
            }
        }
    }

    // const restartDocumentEventListeners = () => {
    //     document.removeEventListener('keydown', handleKeyDown);
    //     document.addEventListener('keydown', handleKeyDown, { capture: true, once: false });
    // }

    const restartListItems = () => {
        // restartDocumentEventListeners();

        listItems = getListItens();

        let liSuggestions = Object.values(document.getElementsByClassName('liSuggestion'));

        liSuggestions.forEach(li => {
            li.removeEventListener('click', handleSuggestionClick);
        });

        liSuggestions.forEach(li => {
            li.addEventListener('click', handleSuggestionClick);
        });
    }

    const handleKeyPressMainInput = (event) => {
        // console.log('event.key = ', event.key);
        // console.log('event.keyCode: ', event.keyCode)

        let btns = buttons.filter(b => b.key === event.key)

        if (btns.length > 0)
            eval(btns[0]['call'])(event);
        else {
            if (event.keyCode === 40 && suggestions.length > 0) // Arrow Down
                document.getElementsByClassName("liSuggestion")[0].focus();

            else if (event.keyCode === 13 && currentProduct !== null) { // Enter

                let regex = /\*(\d+)$/;
                let str = event.target.value;

                let match = str.match(regex);

                if (match)
                    currentQuantity = match[1];
                else
                    currentQuantity = CONFIG_DATA?.default_qtd || 1;

                addProductToOrder();
            }
        }
    }

    const calculateOrderAmount = (data) => {
        let subtotal = 0, amount;
        data.map(item => { subtotal += item.qtd * item.price - testEmpty(item.discount, 0) + testEmpty(item.addition, 0) })
        setCurrentOrder((prev) => {
            amount = subtotal - prev.discount + prev.addition;
            return { ...prev, subtotal: subtotal, amount: amount }
        });
    }

    const addProductToOrder = () => {
        try {
            let price = convertToNumber(testEmpty(currentProduct.price_promotion, '') !== '' ? currentProduct.price_promotion : currentProduct.salePrice);

            setCurrentOrder(prev => {
                let aux = prev['itens'].concat([{
                    price: price,
                    key: uuidv4(),
                    qtd: currentQuantity,
                    name: currentProduct.name,
                    itemId: currentProduct._id,
                    codigo: currentProduct.codigo,
                    total: currentQuantity * price
                }]);

                calculateOrderAmount(aux)

                prev['itens'] = aux;
                return prev;
            })

            clearCurrentTableItem()
            setCurrentProduct(null)
            setMainInputValue('')
            setMainInputValuePlaceholder(digiteParaBuscar)

        } catch (error) {
            console.log(error);
        }
    }

    const handlePasteMainInput = async (e) => {
        try {
            var clipboardData, pastedData;

            e.stopPropagation();
            e.preventDefault();

            clipboardData = e.clipboardData || window.clipboardData;
            pastedData = clipboardData.getData('Text');

            let filtered = products.filter(item => item.codigo === pastedData)

            if (filtered && filtered.length > 0)
                setSelectedProd(filtered[0]['_id']);

        } catch (error) { }
    }

    const handleChangeMainInput = async (t) => {
        let searchTerm = t.value;

        setMainInputValue(searchTerm);

        // Começa tratamentos para identificar códigos, nomes de produto e funções .... 
        if (searchTerm.length > 2) {

            let searchTermNormalized = normalizeString(searchTerm)
            let auxSuggestions = [];

            let filtered = await filterProducts(searchTermNormalized);
            // console.log('filtered: ', filtered)
            if (filtered.length > 0)
                auxSuggestions = auxSuggestions.concat(filtered)

            // console.log('auxSuggestions: ', auxSuggestions)

            setSuggestions(auxSuggestions);

            // setTimeout(() => {
            // restartListItems();
            // }, 1000);
        }
        else
            setSuggestions([]);
    }

    const filterProducts = async (t) => {
        return products.filter(item => item.normalized.includes(t))
    }

    const changeOrder = (w, r, i) => { //What, Record, Index
        // console.log('changeOrder: ', i, r)
        try {
            let aux = { ...r };

            switch (w) {
                case 'item':

                    setCurrentOrder(prev => {
                        aux.key = uuidv4();
                        aux.price = (typeof aux.price === 'string') ? convertToNumber(aux.price) : aux.price;
                        aux.addition = (typeof aux.addition !== 'undefined') ? ((typeof aux.addition === 'string') ? convertToNumber(aux.addition) : aux.addition) : 0;
                        aux.discount = (typeof aux.discount !== 'undefined') ? ((typeof aux.discount === 'string') ? convertToNumber(aux.discount) : aux.discount) : 0;

                        aux.total = aux.qtd * aux.price - aux.discount + aux.addition;

                        prev['itens'][i] = aux;
                        calculateOrderAmount(prev['itens'])
                        return prev
                    })

                    setCurrentProduct([])
                    setCurrentProduct(null)

                    break;

                case 'client':

                    setCurrentOrder(prev => {
                        prev['client'] = aux;
                        return prev
                    })

                    break;

                case 'order':

                    setCurrentOrder(aux);

                    break;

                case 'payment':
                    // console.log('payment: ', aux);
                    // console.log('currentPaymentIdx: ', currentPaymentIdx);
                    setCurrentPayment(aux);
                    setShowPaymentsList(true);

                    setCurrentOrder(prev => {
                        if (currentPaymentIdx === null)
                            prev.payment.methods.push(aux);
                        else
                            prev.payment.methods[currentPaymentIdx] = aux;

                        // console.log(prev);
                        setCurrentPayment(null);

                        return prev;
                    });

                    calculateOrderPaymentData();

                    break;

                default:
                    break;
            }

        } catch (error) { console.log(error) }
    }

    const calculateOrderPaymentData = () => {
        try {

            setCurrentOrder(prev => {
                let paid = 0;
                prev.payment.methods.map(item => { paid += item.value })

                prev.payment.paid = paid;
                prev.payment.change = (paid > prev.amount) ? (paid - prev.amount) : 0;
                prev.payment.balance = (paid > 0) ? (prev.amount - paid) : prev.amount;
                prev.payment.balance = (prev.payment.balance < 0) ? 0 : prev.payment.balance;

                return prev;
            })

        } catch (error) { console.log(error) }
    }

    const tableRowClick = (r, i) => {
        setCurrentTableItem(r);
        setCurrentTableItemIdx(i);
        showValueInputs();
    }

    const tablePaymentsRowClick = (r, i) => {
        setCurrentPayment(r);
        setCurrentPaymentIdx(i);
        finishOrder(null)
    }

    const showValueInputs = () => {
        setCurrentComponent('value_inputs');
    }

    const testCurrentComponentToDefault = () => {
        // console.log('testCurrentComponentToDefault .. ')
        if (CurrentComponent !== 'logo' && !showPaymentsList)
            restoreDefaultComponent();
    }

    let columns = [
        {
            title: 'ITEM',
            dataIndex: 'codigo',
            key: 'codigo',
            width: '5%'
        },
        {
            title: 'DESCRIÇÃO',
            dataIndex: 'name',
            key: 'name',
            width: '70%'
        },
        {
            title: 'QTD.',
            dataIndex: 'qtd',
            key: 'qtd',
            width: '5%',
            align: 'center'
        },
        {
            title: 'PREÇO',
            dataIndex: 'price',
            key: 'price',
            width: '10%',
            align: 'right',
            render: (t) => {
                return (
                    <span>{formatMoney(t)}</span>
                );
            }
        },
        {
            title: 'TOTAL',
            dataIndex: 'total',
            key: 'total',
            width: '10%',
            align: 'right',
            render: (t) => {
                return (
                    <span>{formatMoney(t)}</span>
                );
            }
        },
    ];

    let columnsPayments = [
        {
            title: 'FORMA',
            dataIndex: 'paymentFormName',
            key: 'paymentFormName',
            width: '45%'
        },
        {
            title: 'CONDIÇÃO',
            dataIndex: 'condictionName',
            key: 'condictionName',
            width: '45%'
        },
        {
            title: 'VALOR',
            dataIndex: 'value',
            key: 'value',
            width: '10%',
            align: 'right',
            render: (t) => {
                return (
                    <span>{formatMoney(t)}</span>
                );
            }
        }
    ];

    const clearCurrentTableItem = () => {
        setCurrentTableItem(null)
        setCurrentTableItemIdx(null)
    }

    const restoreDefaultComponent = () => {
        // console.log('restoreDefaultComponent ... ')
        setCurrentComponent('logo')
    }

    const removeSomething = (what, ref, idx) => {
        // console.log('cancelSomething: ', what, ref)

        switch (what) {
            case 'payment':
                if (ref !== null && idx !== null) {
                    setCurrentOrder(prev => {
                        prev.payment.methods.splice(idx, 1);
                        calculateOrderPaymentData();
                        setCurrentPayment(null)
                        setCurrentPaymentIdx(null)
                        return prev;
                    })
                }
                break;

            case 'item':
                if (ref !== null && idx !== null) {
                    setCurrentOrder(prev => {
                        prev['itens'].splice(idx, 1);
                        calculateOrderAmount(prev['itens']);
                        return prev;
                    })

                    clearCurrentTableItem()
                    restoreDefaultComponent()
                }

                break;
        }
    }

    const cancelSomething = (what, ref, idx) => {
        // console.log('cancelSomething: ', what, ref)

        switch (what) {
            case 'payment':
                setCurrentPayment(null)
                setCurrentPaymentIdx(null)
                restoreDefaultComponent()
                // console.log('currentOrder.payment.methods.length: ', currentOrder.payment.methods.length)
                if (currentOrder.payment.methods.length === 0)
                    setShowPaymentsList(false);
                break;

            case 'item':
                clearCurrentTableItem()
                restoreDefaultComponent()

            default:
                restoreDefaultComponent()
                setShowPaymentsList(false);
                break;
        }
    }

    const sincOrder = async (order, callback) => {
        try {
            await apiPDV.saveOrder(order).then(res => {

                // if (res.data === 'ok')
                //     apiPDV.setSincronizedOrder(order.local_id, { ...order, status: OrderStatus.Sincronized });

                callback(res);
            });
        } catch (error) {
            callback({ data: 'ok' });
        }
    }

    const beforeSaveOrder = () => {
        try {
            createNewOrder();
            setMainInputValue('')
            restoreDefaultComponent()
            setShowPaymentsList(false);
            setMainInputValuePlaceholder(caixaLivre)
        } catch (error) { }
    }

    const finishSomething = async (what, ref) => {

        switch (what) {
            case 'payment':

                sincOrder(currentOrder, (res) => {

                    let p = currentOrder.payment.methods.find(m => m.paymentFormMethod === 'PIX');

                    if (p) {

                        if (!res.data.error) {
                            if (!res.data?.stock?.error) {
                                handleNFCe(res.data._id)
                                beforeSaveOrder();
                            }
                            else
                                alert('Erro ao gerar venda.. Estoque indisponível');

                            showPix(p.value + '');
                        }
                    }
                    else {
                        if (!res.data.error) {
                            if (!res.data?.stock?.error) {
                                handleNFCe(res.data._id)
                                beforeSaveOrder();
                            } else
                                alert('Erro ao gerar venda.. Estoque indisponível');
                        }
                        else
                            alert('Erro ao sincronizar venda..');
                    }
                })

                break;

            default:
                restoreDefaultComponent()
                setShowPaymentsList(false);
                break;
        }
    }

    const setViewPIX = (payload) => {
        console.log('payload: ', payload)
    }

    const [openNFCe, setOpenNFCe] = useState(false);
    const [loadNFCe, setLoadNFCe] = useState(false);
    const [retornoNFCe, setRetornoNFCe] = useState('');

    const goNFCe = async (lastSaleId) => {
        try {

            showModalNFCe();
            setLoadNFCe(true);

            let data = {
                ...CONFIG_DATA
            };

            let idx = Cfop.findIndex(item => item.value === CONFIG_DATA?.cfop);
            if (idx !== -1) {
                let natureza = Cfop[idx].name;
                natureza = natureza.replace(CONFIG_DATA?.cfop + ' - ', '');
                data['natureza'] = natureza;
            }

            await apiPDV.createNFCeFromOrder(lastSaleId, data).then(async (res) => {

                // console.log(res.data)

                setLoadNFCe(false);

                if (res.data?.error)
                    notificationMessage('error', res.data.message)
                else {

                    setOpenNFCe(false)

                    refEmissaoModal.current.showModal(res.data, 'nfce');
                }
            }).catch(erro => {
                setLoadNFCe(false);
                notificationMessage('error', erro)
                console.error(erro)
            })

        } catch (error) {
            console.log(error);
        }
    }

    const afterEmitNFCe = (id) => {
        try {
            // console.log('afterEmitNFCe: ', id);
            return '';
            notasApi.displayNota(id).then(response => {
                const blob = new Blob([response.data], { type: response.headers.get('content-type') });
                // console.log(blob);
                // DesktopWSControll.send('command', { 'name': 'print', file: 'nfce', data:blob });
                // window.open(URL.createObjectURL(blob));
            });
        } catch (error) {
            console.log(error);
        }
    }

    const handleNFCe = (lastSaleId) => {
        try {
            if (CONFIG_DATA?.emissao === '1')
                goNFCe(lastSaleId);

            else if (CONFIG_DATA?.emissao === '2') {
                confirm({
                    title: 'Atenção',
                    okText: 'Sim, emitir agora!',
                    cancelText: 'Não',
                    icon: <ExclamationCircleFilled />,
                    content: ('Deseja emitir a nota fiscal do consumidor?'),
                    onOk() {
                        goNFCe(lastSaleId);
                    },
                    onCancel() {
                        beforeSaveOrder()
                    }
                })
            }
            else
                beforeSaveOrder()

        } catch (error) {
            console.log(error)
        }
    }

    const showModalNFCe = () => {
        setOpenNFCe(true)
    }

    const closeModalNFCe = () => {
        setOpenNFCe(false)
    }

    // ESTAS FUNÇÕES SÃO CHAMADAS NO FOREACH ABAIXO, DEIXAR AQUI !!!!!!
    const showHelp = (event) => {
        event.preventDefault();
        alert('HEEELLLPPPPP');
    }

    const selectCustumer = (event) => {
        event.preventDefault();
        setCurrentComponent('select_client');
    }

    const requestCancelItem = (event) => {
        event.preventDefault();
        if (currentTableItem !== null)
            setCurrentComponent('cancel_Item');
    }

    const finishOrder = (event) => {
        if (event)
            event.preventDefault();

        setMainInputValue('')
        calculateOrderPaymentData();
        setCurrentComponent('finalizar_venda')
        setMainInputValuePlaceholder(finalizarVenda)
        setShowPaymentsList(true);
    }

    const cancelOrder = (event) => {
        if (event)
            event.preventDefault();

        Modal.confirm({
            zIndex:1003,
            title: 'Confirmação',
            okText: 'Cancelar venda finalizada',
            onOk: () => handleCancel('finalizada'),
            onCancel: () => handleCancel('atual'),
            cancelText: 'Cancelar venda atual',
            content: 'Deseja cancelar a venda atual ou alguma venda já finalizada?'
        });
    }

    const handleCancel = (option) => {
        if(option === 'atual')
            createNewOrder();
        else
            setOpenCancelModal(true)
    }

    const withdrawalCashBox = (event) => {
        if(CONFIG_DATA.control_cash === 'S') {
            if (event)
                event.preventDefault();

            setCurrentCashBoxMovement({
                value: 0,
                motive: '',
                type: 'Saida',
                category: 'Sangria',
                cashbox_id: CONFIG_DATA.cashbox
            })
            setOpenCashBoxMovementModal(true);
        }
    }
    
    const supplyCashBox = (event) => {
        if(CONFIG_DATA.control_cash === 'S') {
            if (event)
                event.preventDefault();

            setCurrentCashBoxMovement({
                value: 0,
                motive: '',
                type: 'Entrada',
                category: 'Suprimento',
                cashbox_id: CONFIG_DATA.cashbox
            })
            setOpenCashBoxMovementModal(true);
        }        
    }

    const closeCashBox = (event) => {
        if(CONFIG_DATA.control_cash === 'S') {
            if (event)
                event.preventDefault();

            setCanUse(false)
            setCloseCashRegister(true)
       }
    }

    const requestDiscountOrAddictionToOrder = (event) => {
        event.preventDefault();
        if (currentOrder.amount > 0)
            setCurrentComponent('acrescimo_desconto_venda')
    }

    const closeCancelModal = () => {
        setOpenCancelModal(false);
    }

    buttons.forEach(element => {
        useHotkeys(element.key, eval(element.call));
    });

    /**  GESTÃO DE CAIXA */

    const handleOpenCashBox = () => {
        try {
            setLoadButton(true);
            cashBoxApi.openCashBox(startCashBoxData).then(r => {
                
                setLoadButton(false);

                if (!r.data.error) {
                    setCanUse(true);
                    setOpenCashRegister(false);

                    CONFIG_DATA.cashbox = r.data.id;

                    setStartCashBoxData( (prev) => {
                        prev['id'] = r.data.id;
                        return prev;
                    } );

                    setCurrentOrder((prev) => {
                        return { ...prev, cashboxId: CONFIG_DATA.cashbox }
                    });
                }
                else
                    alert('Erro ao abrir caixa.. tente novamente em breve.');
            })
            
        } catch (error) {
        }
    }

    const cancelCloseCashBox = () => {
        setCloseCashRegister(false)
        setCanUse(true)
    }

    const handleCloseCashBox = () => {
        try {
            setLoadButton(true);
            cashBoxApi.closeCashBox(startCashBoxData).then(r => {
                
                setLoadButton(false);

                if (!r.data.error && r.data === 'ok') {
                    setCanUse(false);
                    setOpenCashRegister(true)
                }
                else
                    alert('Erro ao fechar caixa.. tente novamente em breve.');
            })
            
        } catch (error) {
            console.log('handleCloseCashBox error: ', error)
        }
    }

    const handleRegisterCashBoxMovement = () => {
        try {

            if(currentCashBoxMovement.value === 0){
                alert('Informe o valor da movimentação');
                return false;
            }

            if(currentCashBoxMovement.category === 'Sangria' && currentCashBoxMovement.motive.length === 0){
                alert('Informe o motivo da sangria');
                return false;
            }

            setLoadButton(true);

            currentCashBoxMovement.value = convertToNumber(currentCashBoxMovement.value);

            cashBoxApi.registerCashBoxMovement(currentCashBoxMovement).then(r => {
                setLoadButton(false);
                if (!r.data.error) {
                    alert('Movimentação de caixa efetuada com sucesso!');
                    setOpenCashBoxMovementModal(false)
                }
                else
                    alert('Erro ao registrar movimentação de caixa.. tente novamente em breve.');
            })
        } catch (error) {
            console.log('handleRegisterCashBoxMovement error: ', error)
        }
    }

    const handleUpdateCancelData = (data) => {
        data['reasonMovementId'] = CONFIG_DATA.reasonMovementId;
        setCancelSaleData(data)
    }

    const handleCancelSelectedSale = () => {
        try {
            if(!cancelSaleData['orderId'] || cancelSaleData['orderId'].length < 1) {
                alert('Selecione a venda que deseja cancelar.')
                return false;
            }

            if(!cancelSaleData['checkedList'] || cancelSaleData['checkedList'].length < 1) {
                alert('Selecione ao menos 1 item de produtos para cancelar.')
                return false;
            }

            if(!cancelSaleData['motive'] || cancelSaleData['motive'].length < 1) {
                alert('Informe o motivo do cancelamento.')
                return false;
            }

            setLoadCancelSale(true);

            apiPDV.cancelOrder(cancelSaleData).then(res => {
                setLoadCancelSale(false);
                alert('Venda cancelada com sucesso!')
                closeCancelModal();
            });

        } catch (error) {
            console.log('handleCancelSelectedSale error: ', error);
        }
    }

    return (
        canUse ?
            <div onKeyDown={handleKeyDown}>
                <TopBar ref={refTopBar} currentOrder={currentOrder} products={products} cor={topFootColor} isOnline={isOnline} />
                <Layout className='pdvLayout'>
                    <Row gutter={24} className='textCenter'>
                        <Col span={24}>
                            <div className='contentMainInput'>
                                <Input type='text' placeholder={mainInputValuePlaceholder} value={mainInputValue} className='mainInput' tabIndex={1}
                                    onPaste={handlePasteMainInput}
                                    onChange={(event) => handleChangeMainInput(event.target)}
                                    onFocus={(event) => { event.target.select(); testCurrentComponentToDefault() }}
                                />
                                <div className='contentMainSuggestions'>
                                    <ul id="mySuggestionsList">
                                        {
                                            suggestions.map((s, i) => {
                                                return <li data-id={s._id} key={`lisugg${i}`} className='liSuggestion' onClick={handleSuggestionClick}>
                                                    {/* tabIndex={i-1} */}
                                                    <Row gutter={24}>
                                                        <Col span={1}>{s.codigo}</Col>
                                                        <Col span={3}>{s.type}</Col>
                                                        <Col span={17} className='textLeft'>{s.name}</Col>
                                                        <Col span={3} className='textRight'>R$ {formatMoney(testEmpty(s.price_promotion, '') !== '' ? s.price_promotion : s.salePrice)}</Col>
                                                    </Row>
                                                </li>
                                            })
                                        }
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {!isOnline && (<div className="isOffline textCenter"><p>Você está offline. Algumas funcionalidades podem não estar disponíveis.</p></div>)}
                    <Row gutter={24} className='textCenter'>
                        <Col span={15}>
                            <div className='contentTableItens' style={{ height: maxVHHeight }}>
                                {
                                    !showPaymentsList ?
                                        <Table showHeader={true} columns={columns} dataSource={[...currentOrder?.itens]} pagination={false} key={'myTableKey'}
                                            style={{ height: '90%', background: '#FFF' }} tabIndex={2} rowKey={'key'}
                                            onRow={(record, rowIndex) => {
                                                return {
                                                    onClick: (event) => { tableRowClick(record, rowIndex) },
                                                }
                                            }} />
                                        :
                                        <Table showHeader={true} columns={columnsPayments} dataSource={[...currentOrder?.payment?.methods]} pagination={false} key={'myTablePaymentsKey'}
                                            style={{ height: '90%', background: '#FFF' }} tabIndex={2} rowKey={'key'}
                                            onRow={(record, rowIndex) => {
                                                return {
                                                    onClick: (event) => { tablePaymentsRowClick(record, rowIndex) },
                                                }
                                            }} />

                                }
                                <div className='contentAmountPrice'>
                                    TOTAL DA COMPRA: R$ {formatMoney(currentOrder?.amount)}
                                </div>
                            </div>
                        </Col>
                        <Col span={9} style={{ textAlign: 'center', paddingLeft: '0px' }}>
                            {
                                CurrentComponent && (Component = All_Components[CurrentComponent]) && (
                                    <Component
                                        maxVHHeight={maxVHHeight}
                                        isOnline={isOnline}
                                        currentTableItem={currentTableItem}
                                        currentTableItemIdx={currentTableItemIdx}
                                        onChange={changeOrder}
                                        currentOrder={currentOrder}
                                        clients={clients}
                                        remove={removeSomething}
                                        cancel={cancelSomething}
                                        close={restoreDefaultComponent}
                                        currentPayment={currentPayment}
                                        currentPaymentIdx={currentPaymentIdx}
                                        finish={finishSomething}
                                        settings={CONFIG_DATA}
                                    />
                                )
                            }
                        </Col>
                    </Row>
                    <Row gutter={24} className='textCenter'>
                        <Col span={24}>
                            <div className='contentBtnsShortCutAction'>
                                {
                                    buttons.map((btn, i) => {
                                        return (
                                            <div className={ btn.class ? `${btn.class} btnShortCutAction` : 'btnShortCutAction' } key={`btn${i}`} onClick={eval(btn.call)}>{btn.label} <br /> {btn.key}</div>
                                        )
                                    })
                                }
                            </div>
                        </Col>
                    </Row>
                </Layout>

                <FooterBar ref={refFooterBar} cor={topFootColor} />

                <Modal
                    width={350}
                    zIndex={1000}
                    open={openKeyPIX}
                    title={`Chave PIX`}
                    onOk={closeModalPix}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <Row gutter={24}>
                        <Col span={24}>
                            <div style={{ padding: '5px', fontSize: '22px', textAlign: 'center' }}>
                                {/* <img src={`data:image/png;base64,${pixKey?.qrCode?.encodedImage}`} style={{width:'100%'}}/> */}
                                <img src={`${pixKey?.qrcode_base64}`} style={{ width: '100%' }} />
                                <b>Nome: {pixKey.name}</b>
                                <br />
                                <b>Valor: R$ {formatMoney(pixKey.amount)}</b>
                                {/* 
                                paymentPIXStatus ? 
                                    <Alert description={`Pagamento recebido!`} type="success" showIcon />
                                : <Alert description="Pagamento pendente..." type="warning" showIcon />
                            */}
                            </div>
                        </Col>
                    </Row>
                </Modal>

                <Modal
                    width={1000}
                    zIndex={1003}
                    cancelText={'Fechar'}
                    open={openCancelModal}
                    onCancel={closeCancelModal}
                    onOk={handleCancelSelectedSale}
                    okText={'Cancelar venda selecionada!'}
                    title={`Cancelamento de vendas finalizadas`}
                >
                    <Row gutter={24}>
                        <Col span={24}>
                            <div style={{ padding: '5px', fontSize: '22px', textAlign: 'center' }}>
                                {(loadCancelSale) ?
                                    <>
                                        <Loader style={{ marginTop: '-20px !important' }} />
                                        <br clear="both" />
                                        <br />
                                        <div style={{ position: 'relative', width: '100%', marginTop: '15px' }}>Cancelando venda...</div>
                                    </>
                                    : 
                                        <CancelSalesModal id={currentOrder.cashboxId} changeData={handleUpdateCancelData}/>
                                    }
                            </div>
                        </Col>
                    </Row>
                </Modal>

                <Modal
                    width={700}
                    zIndex={1000}
                    open={openNFCe}
                    // onCancel={closeModalNFCe}
                    title={`Gerando Nota fiscal do Consumidor`}
                    okButtonProps={{ style: { display: 'none' } }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <Row gutter={24}>
                        <Col span={24}>
                            <div style={{ padding: '5px', fontSize: '22px', textAlign: 'center' }}>
                                {(loadNFCe) ?
                                    <>
                                        <Loader style={{ marginTop: '-10px !important' }} />
                                        <br clear="both" />
                                        <br />
                                        <div style={{ position: 'relative', width: '100%', marginTop: '15px' }}>Gerando NFC-e...</div>
                                    </>
                                    : <>{retornoNFCe}</>}
                            </div>
                        </Col>
                    </Row>
                </Modal>

                <Modal
                    width={500}
                    zIndex={1000}
                    open={openCashBoxMovementModal}
                    footer={
                        <Row>
                            <Col span={24}>
                                <Button key="back" loading={loadButton} onClick={() => setOpenCashBoxMovementModal(false)}>
                                    Cancelar
                                </Button>
                                <Button type='primary' loading={loadButton} key="submit" onClick={handleRegisterCashBoxMovement}>
                                    Registrar movimentação!
                                </Button>
                            </Col>
                        </Row>
                    }
                    title={ currentCashBoxMovement.category === 'Sangria' ? 'Sangria de caixa' : 'Suprimento de caixa'}
                >
                    <Row gutter={24} style={{marginBottom: '30px'}}>
                        <Col span={24}>
                            <Fieldset>
                                <Label>Valor da operação</Label>
                                <MoneyInput
                                    decimalScale={2}
                                    name="value"
                                    placeholder="0,00"
                                    className='ant-input textRight'
                                    value={formatMoney(currentCashBoxMovement.value)}
                                    onChange={(e) => setCurrentCashBoxMovement((prev) => {
                                        prev['value'] = e.target.value;
                                        return prev;
                                    }) }
                                />
                            </Fieldset>
                        </Col>
                        {
                            currentCashBoxMovement.category === 'Sangria' && (
                                <Col span={24}>
                                    <Fieldset>
                                        <Label>Motivo</Label>
                                        <TextArea 
                                            name="motivo"
                                            className='ant-input'
                                            style={{height: '150px', resize:'none'}}
                                            placeholder="Informe o motivo da sangria de caixa"
                                            onChange={(e) => setCurrentCashBoxMovement((prev) => {
                                                prev['motive'] = e.target.value;
                                                return prev;
                                            })}
                                            >{currentCashBoxMovement.motive}</TextArea>
                                    </Fieldset>
                                </Col>
                            )
                        }
                    </Row>
                </Modal>

                <EmissaoModal ref={refEmissaoModal} callbackOk={afterEmitNFCe} />

                {contextHolder}
            </div>
            : 
            (
                openCashRegister ? 
                    <div className="centeredContainer">
                        <div className="centeredContainerBody">
                            <h2>Abertura de caixa</h2>
                            <br/>
                            <Row gutter={24}>
                                <Col span={10}>
                                    Valor atual no caixa:
                                    &nbsp;&nbsp;
                                    <Tooltip
                                            thisTitle={<div>Representa a somatória do valor em dinheiro e cheque que está no caixa neste momento</div>}
                                            thisColor={'white'}
                                            thisKey={'2'}
                                        />
                                </Col>
                                <Col span={14}>
                                    <MoneyInput
                                        decimalScale={2}
                                        name="startValue"
                                        placeholder="0,00"
                                        className='ant-input textRight'
                                        value={formatMoney(startCashBoxData.start)}
                                        onChange={(e) => setStartCashBoxData((prev) => {
                                            prev['startValue'] = e.target.value;
                                            return prev;
                                        }) }
                                    />
                                </Col>
                            </Row>
                            <Row gutter={24} style={{marginTop:'15px'}}>
                                <Col span={10}>Suprimento inicial:</Col>
                                <Col span={14}>
                                    <MoneyInput
                                        decimalScale={2}
                                        name="suprimentValue"
                                        placeholder="0,00"
                                        className='ant-input textRight'
                                        value={formatMoney(startCashBoxData.suprimentValue)}
                                        onChange={(e) => setStartCashBoxData((prev) => {
                                            prev['suprimentValue'] = e.target.value;
                                            return prev;
                                        }) }
                                    />
                                </Col>
                            </Row>
                            <Row gutter={24} style={{marginTop:'15px'}}>
                                <Col span={24}>
                                    <Button type="primary" loading={loadButton} style={{width:'100%', fontSize:'18px', height: '40px'}} onClick={handleOpenCashBox}>
                                        Abrir caixa e iniciar atendimento!
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                :
                (
                    closeCashRegister ? 
                        <div className="centeredContainer">
                            <div className="centeredContainerBody">
                                <h2>Fechamento de caixa</h2>
                                <br/>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        <ListPaymentForms id={currentOrder.cashboxId}/>
                                    </Col>
                                </Row>
                                <Row gutter={24} style={{marginTop:'15px'}}>
                                    <Col span={10} style={{textAlign:'right', paddingTop:'5px'}}>
                                        <b>
                                            Valor atual no caixa:
                                        </b>
                                        &nbsp;&nbsp;
                                        <Tooltip
                                            thisTitle={<div>Representa a somatória do valor em dinheiro e cheque que está no caixa neste momento</div>}
                                            thisColor={'white'}
                                            thisKey={'2'}
                                        />
                                    </Col>
                                    <Col span={14}>
                                        <MoneyInput
                                            decimalScale={2}
                                            name="startValue"
                                            placeholder="0,00"
                                            className='ant-input textRight'
                                            value={formatMoney(startCashBoxData.start)}
                                            onChange={(e) => setStartCashBoxData((prev) => {
                                                prev['startValue'] = e.target.value;
                                                return prev;
                                            }) }
                                        />
                                    </Col>
                                </Row>
                                <Row gutter={24} style={{marginTop:'15px'}}>
                                    <Col span={12}>
                                        <Button type="primary" loading={loadButton} style={{width:'100%', fontSize:'18px', height: '40px'}} onClick={cancelCloseCashBox}>
                                            Cancelar
                                        </Button>
                                    </Col>
                                    <Col span={12}>
                                        <Button type="primary" loading={loadButton} style={{width:'100%', fontSize:'18px', height: '40px'}} onClick={handleCloseCashBox}>
                                            Fechar caixa!
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    :
                        <>Carregando dados de caixa...</>
                )
            )
    );
}